<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Modal } from "bootstrap";

defineProps({
  title: {
    type: String,
    default: "<<Title goes here>>",
  },
  static: {
    type: Boolean,
    default: false
  },
  hideClose: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: null
  }
});

let modalEle = ref(null);
let thisModalObj: any = null;

onMounted(() => {
  if (modalEle.value) {
    thisModalObj = new Modal(modalEle.value);
  }
});

const _show = () => {
  thisModalObj.show();
  if (thisModalObj._element) {
    thisModalObj._element.style.paddingRight = '0px'
  }
}

const _hide = () => {
  thisModalObj.hide();
}

defineExpose({
  show: _show,
  hide: _hide
});

</script>

<template>
  <div class="modal fade" id="proModal" tabindex="-1" aria-labelledby="" aria-hidden="true" ref="modalEle"
    :data-bs-backdrop="static ? 'static' : 'true'" :data-bs-keyboard="static ? 'false' : 'true'">
    <div class="modal-dialog modal-dialog-centered" :style="width ? `max-width: ${width}` : ''">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="proModalLabel">{{ title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="!hideClose"></button>
        </div>
        <div class="modal-body">
          <slot name="body" />
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" v-if="!hideClose">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.modal-backdrop {
  width: 100% !important;
  height: 100% !important;
}

@media screen and (max-width: 600px) {
  .modal-dialog {
    max-width: 98% !important;
  }
}

.modal-inline {
  width: 100vw !important;
  max-width: 100vw;
  max-height: 100vh;
}
</style>